import { render, staticRenderFns } from "./OfficialsPg.vue?vue&type=template&id=3517e827&scoped=true&"
import script from "./OfficialsPg.vue?vue&type=script&lang=js&"
export * from "./OfficialsPg.vue?vue&type=script&lang=js&"
import style0 from "./OfficialsPg.vue?vue&type=style&index=0&id=3517e827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3517e827",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
